export default {
  admin_roles: [
    { label: 'Admin', value: 'admin_admin' },
    { label: 'Editor', value: 'admin_editor' },
    { label: 'Viewer', value: 'admin_viewer' },
  ],
  seller_roles: [
    { label: 'Owner', value: 'seller_owner' },
    { label: 'Admin', value: 'seller_admin' },
    { label: 'Sales', value: 'seller_sales' },
    { label: 'Analys', value: 'seller_analyst' },
    { label: 'Inventory Manager', value: 'seller_inventory_manager' },
  ],
  buyer_roles: [{ label: 'Member', value: 'buyer_member' }],
}
